<template>
  <div class="live-materials">
    <div class="materials-group">
      <div class="material-item" v-for="item in creativeCount" :key="item">
        <div class="material-name">
          <i class="el-icon-video-play material-icon"></i>
          <span>直播素材组 {{ item }}</span>
        </div>
        <span class="remove-icon" :class="creativeCount > 1 && 'el-icon-error'" @click="onRemove(item)"></span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue'
const { configForm, updateConfigForm } = inject('configForm')

const creativeCount = computed(() => configForm.value.creatives.length)
const onRemove = (item) => {
  if (creativeCount.value <= 1) return
  updateConfigForm({
    ...configForm.value,
    creatives: configForm.value.creatives.filter((_, index) => index !== item - 1)
  })
}
</script>

<style scoped lang="scss">
.live-materials {
  height: 720px;
  overflow: auto;

  .materials-group {
    padding: 12px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    grid-gap: 12px;

    .material-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 14px;
      border: 1px solid #ebeef5;
      border-radius: 8px;
      background-color: #fff;
      transition: box-shadow 0.2s ease, transform 0.2s ease;

      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
        transform: translateY(-1px);
      }

      .remove-icon {
        font-size: 14px;
        cursor: pointer;
      }

      .material-name {
        display: flex;
        align-items: center;
        color: #303133;
        font-size: 14px;
        font-weight: 500;
        .material-icon {
          margin-right: 8px;
          color: #909399;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
